import '../../src/App.css';
import '../../src/Css/bootstrap.min.css';
import Login from '../../src/Pages/login';
import HomePage from './pages/index';
import Loader from 'react-loader-spinner';
import { useState, useEffect, Fragment } from 'react';
import PopupMenu from '../Components/PopupMenu';
import ModalAboutUs from "../Components/Modals/ModalAboutUs";
import ModalDialog from '../Components/Modals/ModalDialog';
import MenuWide from '../Components/Header/MenuWide';
import Menu from "../Components/Header/Menu";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Invoice from './pages/Invoice';
import SearchInvoice from './pages/SearchInvoice';
import PrintViewer from '../Pages/PrintViewer';
import { getActiveSubsystems, isMobileApp, isWebApp } from '../store/api/CommonFunctions';
import { useDispatch } from 'react-redux';
import SearchCommands from '../Pages/SearchCommands';
import StorageStatusReport from './pages/StorageStatusReport';
import InventoryTurnoverReport from './pages/InventoryTurnoverReport';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import TaxPayerInvoices from './pages/TaxPayerInvoices';
import UserDashboard from '../Pages/UserDashboard';
import SearchFormalInvoice from './pages/SearchFormalInvoice';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchSentSMS from '../Pages/SearchSentSMS';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import InvoiceDetailsReport from './pages/InvoiceDetailsReport';
import StorageValueReport from './pages/StorageValueReport';
import ProductSerialTurnoverInStorage from './pages/ProductSerialTurnoverInStorage';
import InventoryTurnoverReportForAllProducts from './pages/InventoryTurnoverReportForAllProducts';

const requireAuth = (setUser) => {

  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App() {
  const dispatch = useDispatch();
  const [QAList, setQAList] = useState([]);
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [menuWidth, setMenuWidth] = useState(false);
  const [showAboutUs, setModalAboutUs] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());
    document.getElementById("CompanyName")?.setAttribute("systemname", "سیستم فروش");
  }, []);
  return (
    <div className="App">
      <Router>
        {currentUser &&
          <Fragment>
            <ModalDialog />
            <PopupMenu />
            <ModalAboutUs show={showAboutUs} setModalAboutUs={setModalAboutUs} />
            <div style={{ height: "20px" }}>
              {isMobileApp() && !window.location.href.contains("SMSInvoice") && <Menu menuName="Sale" />}
              {isWebApp() && !window.location.href.contains("SMSInvoice") &&
                <Fragment>
                  <span style={{ fontSize: "30px", cursor: "pointer", position: "absolute", right: "15px", top: "6px" }} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="Sale" setQAList={setQAList} />
                </Fragment>}
            </div>
            <Switch>
              <Route path="/Sale/Invoice/:invoiceType/:invoiceID/:isFormal"><Invoice /></Route>
              <Route path="/Sale/SearchInvoice"><SearchInvoice /></Route>
              <Route path="/Sale/SearchFormalInvoice"><SearchFormalInvoice /></Route>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/Sale/StorageStatusReport"><StorageStatusReport /></Route>
              <Route path="/Sale/InventoryTurnoverReport"><InventoryTurnoverReport /></Route>
              <Route path="/Sale/InventoryTurnoverForAllProducts"><InventoryTurnoverReportForAllProducts/></Route>
              <Route path="/Sale/TaxPayerInvoices"><TaxPayerInvoices /></Route>
              <Route path="/Sale/InvoiceDetailsReport"><InvoiceDetailsReport /></Route>
              <Route path="/Sale/StorageValueReport"><StorageValueReport /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/Sale/ProductSerialTurnoverInStorage"><ProductSerialTurnoverInStorage/></Route>
              <Route path={userInfo?.HomePage === "Sale" ? "/" : "/Sale"}><HomePage /></Route>

            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}

        {!pending && !currentUser && !forgetPassword &&
          <Login setUser={setUser} setForgetPassword={setForgetPassword} />}
      </Router>
    </div>
  );
}

export default App;
